import axios from 'axios'

const CHAVE_DEVICE_ID = '_hsmapp_deviceid_'
const HEADER_DEVICE_ID = 'deviceid'

// Cache em memoria para nao ir ao localStorage a cada requisicao.
let deviceIdCache = ""

// Gera um UUID v4 sem dependencia externa.
function gerarUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.floor(Math.random() * 16)
        const v = c === 'x' ? r : ((r % 4) + 8)
        return v.toString(16)
    })
}

// Identificador do navegador. Criado uma unica vez e mantido no localStorage,
// para o backend saber de qual dispositivo veio a requisicao.
// Observacao: limpar os dados do site gera um novo id.
export function getDeviceId() {
    if (deviceIdCache) return deviceIdCache

    try {
        const salvo = localStorage.getItem(CHAVE_DEVICE_ID)
        if (salvo) {
            deviceIdCache = salvo
            return deviceIdCache
        }

        const novo = gerarUUID()
        localStorage.setItem(CHAVE_DEVICE_ID, novo)
        deviceIdCache = novo
        return deviceIdCache
    } catch (e) {
        // Sem storage disponivel a requisicao segue sem o identificador.
        return ""
    }
}

// Envia o deviceId no header de toda requisicao. Registrado uma unica vez no
// axios padrao, usado por toda a camada de rede (util/metodos.js).
export function registrarDeviceIdNasRequisicoes() {
    axios.interceptors.request.use(config => {
        const deviceId = getDeviceId()

        if (deviceId) {
            config.headers = config.headers || {}
            config.headers[HEADER_DEVICE_ID] = deviceId
        }

        return config
    })
}
